import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'

import { useBooleanState } from 'hooks/useBooleanState'

export const EventTypeDeletePopup = ({ name, onConfirm, onClose, isOpen }) => {
  const [isDeleting, setIsDeleting] = useBooleanState(false)

  const onClick = () => {
    setIsDeleting()
    onConfirm()
  }

  return (
    <Popup isOpen={isOpen} onClose={onClose} title={I18n.t('publisher.event_types.delete.heading', { name })}>
      <Body>{I18n.t('publisher.event_types.delete.note')}</Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>{I18n.t('publisher.action.cancel')}</Button>
        <Button decoration="danger" onClick={onClick} loading={isDeleting}>{I18n.t('publisher.action.yes')}</Button>
      </Footer>
    </Popup>
  )
}
